export type TenantBankAccount = {
  bankName: string;
  accountName: string;
  accountNumber: string;
  isPrimary: boolean;
  currencyCode: string | null;
  swiftBic: string | null;
  iban: string | null;
};
